var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"transparent mt-6 mt-lg-12 mb-6",attrs:{"flat":"","tile":""}},[_c('p',{staticClass:"secondary--text text-overline mb-0"},[_vm._t("subheader")],2),_c('h2',{staticClass:"font-title-2 sm__font-title-2 primary--text mb-0"},[_vm._t("page-title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }